import { __extends, __makeTemplateObject } from "tslib";
import React, { Component } from 'react';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import Tooltip from '@atlaskit/tooltip';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { MediaSingle as UIMediaSingle, WidthConsumer, MediaLink, MediaLinkWrapper, akEditorFullPageMaxWidth, mapBreakpointToLayoutMaxWidth, akEditorFullWidthLayoutWidth, linkMessages, } from '@atlaskit/editor-common';
import { FullPagePadding } from '../../ui/Renderer/style';
import { PLATFORM, MODE } from '../../analytics/events';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE, } from '../../analytics/enums';
import { getEventHandler } from '../../utils';
var DEFAULT_WIDTH = 250;
var DEFAULT_HEIGHT = 200;
var AkEditorMediaLinkClassName = 'ak-editor-media-link';
var ExtendedUIMediaSingle = styled(UIMediaSingle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .", " {\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* web */\n  @media (any-hover: hover) {\n    .", " {\n      width: 20px;\n      height: 20px;\n\n      /* ShortcutIcon */\n      span[role='img'] {\n        width: initial;\n        height: initial;\n\n        > svg {\n          width: 24px;\n          height: 24px;\n        }\n      }\n    }\n\n    &:not(:hover) {\n      .", " {\n        opacity: 0;\n      }\n    }\n\n    &:focus-within {\n      .", " {\n        opacity: 1;\n      }\n    }\n  }\n  /* mobile */\n  @media (pointer: none) {\n    .", " {\n      width: 36px;\n      height: 36px;\n    }\n  }\n\n  ", " transition: all 0.1s linear;\n"], ["\n  .", " {\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* web */\n  @media (any-hover: hover) {\n    .", " {\n      width: 20px;\n      height: 20px;\n\n      /* ShortcutIcon */\n      span[role='img'] {\n        width: initial;\n        height: initial;\n\n        > svg {\n          width: 24px;\n          height: 24px;\n        }\n      }\n    }\n\n    &:not(:hover) {\n      .", " {\n        opacity: 0;\n      }\n    }\n\n    &:focus-within {\n      .", " {\n        opacity: 1;\n      }\n    }\n  }\n  /* mobile */\n  @media (pointer: none) {\n    .", " {\n      width: 36px;\n      height: 36px;\n    }\n  }\n\n  ",
    " transition: all 0.1s linear;\n"])), AkEditorMediaLinkClassName, AkEditorMediaLinkClassName, AkEditorMediaLinkClassName, AkEditorMediaLinkClassName, AkEditorMediaLinkClassName, function (_a) {
    var layout = _a.layout;
    return layout === 'full-width' || layout === 'wide'
        ? "\n  margin-left: 50%;\n  transform: translateX(-50%);\n  "
        : "";
});
var MediaSingle = /** @class */ (function (_super) {
    __extends(MediaSingle, _super);
    function MediaSingle(props) {
        var _this = _super.call(this, props) || this;
        _this.onExternalImageLoaded = function (_a) {
            var width = _a.width, height = _a.height;
            _this.setState({
                width: width,
                height: height,
            });
        };
        _this.handleMediaLinkClick = function (event) {
            var _a = _this.props, fireAnalyticsEvent = _a.fireAnalyticsEvent, eventHandlers = _a.eventHandlers, isLinkMark = _a.isLinkMark, marks = _a.marks;
            if (fireAnalyticsEvent) {
                fireAnalyticsEvent({
                    action: ACTION.VISITED,
                    actionSubject: ACTION_SUBJECT.MEDIA_SINGLE,
                    actionSubjectId: ACTION_SUBJECT_ID.MEDIA_LINK,
                    eventType: EVENT_TYPE.TRACK,
                    attributes: {
                        platform: PLATFORM.WEB,
                        mode: MODE.RENDERER,
                    },
                });
            }
            var handler = getEventHandler(eventHandlers, 'link');
            if (handler) {
                var linkMark = marks.find(isLinkMark);
                handler(event, linkMark && linkMark.attrs.href);
            }
        };
        _this.state = {}; // Need to initialize with empty state.
        return _this;
    }
    MediaSingle.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var child = React.Children.only(React.Children.toArray(props.children)[0]);
        var _a = child.props, _b = _a.width, width = _b === void 0 ? DEFAULT_WIDTH : _b, _c = _a.height, height = _c === void 0 ? DEFAULT_HEIGHT : _c, type = _a.type;
        if (type === 'external') {
            var _d = this.state, stateWidth = _d.width, stateHeight = _d.height;
            if (width === null) {
                width = stateWidth || DEFAULT_WIDTH;
            }
            if (height === null) {
                height = stateHeight || DEFAULT_HEIGHT;
            }
        }
        if (width === null) {
            width = DEFAULT_WIDTH;
            height = DEFAULT_HEIGHT;
        }
        var linkMark = props.marks.find(props.isLinkMark);
        var openLinkMessage = props.intl.formatMessage(linkMessages.openLink);
        // TODO: put appearance-based padding into theme instead
        var rendererAppearance = this.props.rendererAppearance;
        var padding = rendererAppearance === 'full-page' ? FullPagePadding * 2 : 0;
        return (React.createElement(WidthConsumer, null, function (_a) {
            var containerWidth = _a.width, breakpoint = _a.breakpoint;
            var _b = _this.props, isInsideOfBlockNode = _b.isInsideOfBlockNode, allowDynamicTextSizing = _b.allowDynamicTextSizing;
            var cardWidth = containerWidth;
            var cardHeight = (height / width) * cardWidth;
            var cardDimensions = {
                width: cardWidth + "px",
                height: cardHeight + "px",
            };
            var isFullWidth = rendererAppearance === 'full-width';
            var nonFullWidthSize = containerWidth;
            if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
                var isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= akEditorFullPageMaxWidth;
                if (isContainerSizeGreaterThanMaxFullPageWidth &&
                    allowDynamicTextSizing) {
                    nonFullWidthSize = mapBreakpointToLayoutMaxWidth(breakpoint);
                }
                else if (isContainerSizeGreaterThanMaxFullPageWidth) {
                    nonFullWidthSize = akEditorFullPageMaxWidth;
                }
                else {
                    nonFullWidthSize = containerWidth - padding;
                }
            }
            var lineLength = isFullWidth
                ? Math.min(akEditorFullWidthLayoutWidth, containerWidth - padding)
                : nonFullWidthSize;
            var originalDimensions = {
                height: height,
                width: width,
            };
            return (React.createElement(ExtendedUIMediaSingle, { layout: props.layout, width: width, height: height, lineLength: isInsideOfBlockNode ? containerWidth : lineLength, containerWidth: containerWidth, pctWidth: props.width, fullWidthMode: isFullWidth, blockLink: linkMark && linkMark.attrs.href },
                React.createElement(React.Fragment, null,
                    linkMark && linkMark.attrs.href ? (React.createElement(Tooltip, { content: openLinkMessage, position: "top", tag: MediaLinkWrapper, delay: 0 },
                        React.createElement(MediaLink, { href: linkMark.attrs.href, target: "_blank", rel: "noreferrer noopener", className: AkEditorMediaLinkClassName, onClick: _this.handleMediaLinkClick },
                            React.createElement(ShortcutIcon, { label: linkMark.attrs.href, size: "large" })))) : null,
                    React.cloneElement(child, {
                        resizeMode: 'stretchy-fit',
                        cardDimensions: cardDimensions,
                        originalDimensions: originalDimensions,
                        onExternalImageLoaded: _this.onExternalImageLoaded,
                        disableOverlay: true,
                    }))));
        }));
    };
    return MediaSingle;
}(Component));
export default injectIntl(MediaSingle);
var templateObject_1;
//# sourceMappingURL=mediaSingle.js.map